import React, { useContext, useEffect, useState } from 'react'
import Select from "react-select"
import Logo_path from '../../Components/Logo_path'
import { addcontext } from '../../ContextShare/ContextShare'
import TableSearch from './TableSearch'
import GridSearch from './GridSearch'
import { FilterSearchResultData, GetAllMemberIdArray, GetAllMemberIdArrayWithSession, GetEventListForSearchFilter, GetKlaListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla } from '../../Services/allApi'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Icon } from '@iconify/react';
import language from '../../language.json'
import usePersistedState from '../../hooks/usePersistedState'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
function SearchResult() {
    // const {paginationForGovernerAddress,setPaginationForGovernerAddress}=useContext(addcontext)
    const {searchError,setSearchError}=useContext(addcontext)
    const {isSearchOrAdSearch,setIsSearchOrAdSearch}=useContext(addcontext)
    const{totalSearchResults,seTtotalSearchResults}=useContext(addcontext)
    const{totalSearchResultsNS,seTtotalSearchResultsNS}=useContext(addcontext)
    const {paginationStartIndex,setPaginationStartIndex}=useContext(addcontext)
    const {paginationEndIndex,setPaginationEndIndex}=useContext(addcontext)
    const { filterSearchResults, setFilterSearchResults } = useContext(addcontext)
    const { InitialSearchQuery, setInitialSearchQuery } = useContext(addcontext)
    const [startDate, setStartDate] = usePersistedState(`filters.search.${InitialSearchQuery}.startDate`, null);
    const [endDate, setEndDate] = usePersistedState(`filters.search.${InitialSearchQuery}.endDate`, null);
    const [isGridView, setIsGridView] = useState(false)
    const [getGalistData, setGetGalistData] = useState([])
    const { archivesPaginationTotal, setarchivesPaginationTotal } = useContext(addcontext)
    const { archivesPaginationEnd, setarchivesPaginationEnd } = useContext(addcontext)
    const { archivesPaginationStart, setarchivesPaginationStart } = useContext(addcontext)
    const [errorMessage,setErrorMessage]=useState()
    const [klaList, setKlaList] = useState([]);
    const [sessionList, setSessionList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [selectedOptionKla, setSelectedOptionKla] = usePersistedState(`filters.search.${InitialSearchQuery}.selectedOptionKla`, null)
    const [clearedAllFilter,setclearedAllFilter]=useState(false)
    const handlechange = (selectedOptionKla) => {
        setSelectedOptionKla(selectedOptionKla)
        setSelectedOptionsession(null)
        setselectedOptionMember(null)
        setisFilterCleared(true)
    }
    const [selectedOptionsession, setSelectedOptionsession] = usePersistedState(`filters.search.${InitialSearchQuery}.selectedOptionsession`, null)
    const handlechangesession = (selectedOptionsession) => {
        setSelectedOptionsession(selectedOptionsession)
        setselectedOptionMember(null)
        setisFilterCleared(true)
    }
    const [selectedOptionEvent, setselectedOptionEvent] = usePersistedState(`filters.search.${InitialSearchQuery}.selectedOptionEvent`, null)
    const handlechangeEvent = (selectedOptionEvent) => {
        setselectedOptionEvent(selectedOptionEvent)
        setisFilterCleared(true)
    }
    const [selectedOptionMember, setselectedOptionMember] = usePersistedState(`filters.search.${InitialSearchQuery}.selectedOptionMember`, null)
    const handlechangeMember = (selectedOptionMember) => {
        setselectedOptionMember(selectedOptionMember)
        setisFilterCleared(true)
    }
    const [isFilterCleared, setisFilterCleared] = usePersistedState(`filters.search.${InitialSearchQuery}.isFilterCleared`)
    const {langChanged,setlangChanged}=useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();
    const [isFiltered, setIsFiltered] = usePersistedState(`filters.search.${InitialSearchQuery}.isFiltered`, false)
    useEffect(()=>{
        setCurrentLanguage(localStorage.getItem('language')||'en')
  },[currentLanguage,langChanged])

    // Fetch KLA List
    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaList(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApi();
    }, []);

    const klaoptions = klaList.map((item) => ({
        value: item.kla_id,
        label: `${language.kla[currentLanguage]}${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApi = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionList(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApi();
    }, [selectedOptionKla]);

    const sessionoptions = sessionList.map((item) => ({
        value: item.session_id,
        label: `${language.Session[currentLanguage]}${item.session_no}`,
    }));

    // Fetch Event List
    const EventListCallApi = async () => {
        try {
            const resultEvent = await GetEventListForSearchFilter();
            setEventList(resultEvent?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Event list for filter:", error);
        }
    };

    useEffect(() => {
        EventListCallApi();
    }, []);

    const eventoptions = eventList.map((item) => ({
        value: item.event_id,
        label:currentLanguage=='en'?item.event_name:item?.mal_event_name

    }));

    // Fetch Member List
    const MemberListCallApi = async () => {

        try {
            // const resultMember =selectedOptionsession? await GetMemberListForSearchFilterWithSession({session_id:selectedOptionsession?.value}):await GetMemberListForSearchFilter();
            const resultMember =selectedOptionsession? await GetAllMemberIdArrayWithSession({session_id:selectedOptionsession?.value}):await GetAllMemberIdArray();
            console.log(resultMember);
            setMemberList(resultMember?.data || []); 
        } catch (error) {
            console.error("Error fetching Member list for filter:", error);
        }
    };

    useEffect(() => {
        MemberListCallApi();
    }, [selectedOptionsession]);
    
    const handleStartDate=(StDate)=>{
        setStartDate(StDate)
        setisFilterCleared(true)
    }
    const handleEndDate=(EnDate)=>{
        setEndDate(EnDate)
        setisFilterCleared(true)
    }
    const memberoptions = memberList.map((item) => ({
        value: item.member,
        label: currentLanguage === 'en' ? item.member : item?.malayalam_member_name,
        memberIds: item.id
    }));

    // filter table data
    const FilterArchives = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        const memberIds = selectedOptionMember?.memberIds;
        const event_id = selectedOptionEvent?.value;
        const start_date = startDate;
        const end_date = endDate;
        const obj = {};
        obj.search_query = InitialSearchQuery;
        obj.kla_id = kla_id || null;
        obj.session_id = session_id || null;
        obj.member_id = memberIds ? (Array.isArray(memberIds) ? memberIds : [memberIds]) : [];
        obj.event_id = event_id || null;
        obj.start_date = start_date || null;
        obj.end_date = end_date || null;
        // if (constituency_id) obj.constituency_id = constituency_id;
        // const initial_search_query={initial_search_query:InitialSearchQuery}
        // const arrayOfsearchQueries=[]
        // arrayOfsearchQueries[0]=initial_search_query
        // arrayOfsearchQueries[1]=obj
        console.log(JSON.stringify(obj, null, 2));
        try {
            
            const result = await FilterSearchResultData(obj,paginationStartIndex,paginationEndIndex);
            console.log(result);
            setFilterSearchResults(result?.data?.data || []);
            setSearchError(result?.response?.data?.message)
                setErrorMessage( result?.response?.data?.message||null)
                if(isSearchOrAdSearch=='as'){
                    seTtotalSearchResults(result.data?.count);
                  }else{
                    seTtotalSearchResultsNS(result.data?.count)
                  }
                // setSearchError()
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession || selectedOptionEvent || selectedOptionMember||startDate||endDate) {
            if(isFilterCleared){
                FilterArchives();
            }
            
        }
    }, [selectedOptionKla, selectedOptionsession, selectedOptionEvent, selectedOptionMember,startDate,endDate,paginationStartIndex,paginationEndIndex]);
    
    // reset filter
    const handleResetFilter=()=>{
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setselectedOptionEvent(null)
        setselectedOptionMember(null)
        // setSelectedOptionEvent(null)
        // setSelectedOptionsubject(null)
        setStartDate('')
        setEndDate('')
        // setclearedAllFilter(false)
        setisFilterCleared(false)
        // FilterArchives()
        setErrorMessage()

    }

    return (
        <>
            <div className='flex flex-col items-center' style={{ height: '100%', width: '100%', fontFamily: 'Ropa sans' }}>
<div className='md:w-11/12 w-full md:mb-10 mb-4'>
        <div><Logo_path AdminOrHome={'Home'} Directory={'Search results'} /></div>
      </div>
      </div>

            <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>

                <div className='w-10/12 flex flex-col'>

                    <div className='text-center'><h2 className='text-xl mt-0'>{language.Search_Results[currentLanguage]}</h2></div>
                    <div className='flex flex-row justify-between'>

                        <div>
                        <div className='text-left text-sm'>
                                {filterSearchResults?.length>0?<h4 className='mt-5'>{language.total_results[currentLanguage]} : {isSearchOrAdSearch=='s'?totalSearchResultsNS:totalSearchResults}</h4>
                                :
                                <>
                                {errorMessage?
                                ''
                                :
                                <>
                                {!searchError&&<Skeleton width={100} />}
                                </>
                                }
                                </>
                                }
                            </div>
                            <div className='text-left text-sm'>
                                {filterSearchResults?.length>0?<h4 className='mt-3'>{language.showing_results[currentLanguage]}  {paginationStartIndex}-{paginationEndIndex} {language.results[currentLanguage]} </h4>
                                :
                                <>
                                {errorMessage?
                                ''
                                :
                                <>
                                {!searchError&&<Skeleton width={110} />}
                                </>
                                }
                                </>
                                }
                            </div>                        </div>

                        {!searchError&&<div>
                            {!isGridView ? <button className='p-2 bg-blue-500 rounded hover:bg-blue-900 mt-5 text-white' onClick={() => setIsGridView(true)}>
                                <i class="fa-regular fa-image me-2"></i>{language.grid_view[currentLanguage]}</button>
                                :
                                <button className='p-2 bg-blue-500 rounded hover:bg-blue-900 mt-5 text-white' onClick={() => setIsGridView(false)}>
                                    <i class="fa-solid fa-table me-2"></i>{language.table_view[currentLanguage]}</button>
                            }
                        </div>}
                    </div>

                    {filterSearchResults === undefined && !searchError ?
                   <>
                    <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap md:mt-8 md:mb-5'>

                    <div className='md:w-40 w-0'>
                        <Skeleton height={30} />
                    </div>
                    <div className='md:w-40 w-full'>
                        <Skeleton height={30} />
                    </div>
                    <div className='md:w-40 w-full'>
                        <Skeleton height={30} />
                    </div>
                    <div className='md:w-40 w-full'>
                        <Skeleton height={30} />
                    </div>
                    <div className='md:w-40 w-full'>
                        <Skeleton height={30} />
                    </div>
                    <div className='md:w-40 w-0'>
                        <Skeleton height={30} />
                    </div>

                    </div>
                    </>
                    :
                    <div className='flex md:flex-row flex-col md:justify-between justify-start flex-wrap mt-5'>

                        <div className='flex flex-col  text-blue-400'>
                        <div style={{visibility:'hidden'}}>end date</div>
                            <Select
                                placeholder={language.kla[currentLanguage]}
                                className='w-full min-w-32 h-9'
                                options={klaoptions}
                                value={selectedOptionKla}
                                onChange={handlechange} />
                        </div>

                        <div className='flex flex-col text-blue-400'>
                        <div style={{visibility:'hidden'}}>end date</div>
                            <Select
                                placeholder={language.Session[currentLanguage]}
                                className='w-full min-w-32 h-9'
                                options={sessionoptions}
                                value={selectedOptionsession}
                                onChange={handlechangesession} />
                        </div>

                        <div className='flex flex-col '>
                        <div style={{visibility:'hidden'}}>end date</div>
                            <Select
                                placeholder={language.Event[currentLanguage]}
                                className='w-full text-blue-400 min-w-52 h-9'
                                options={eventoptions}
                                value={selectedOptionEvent}
                                onChange={handlechangeEvent} />
                        </div>

                        <div className='flex flex-col text-blue-400'>
                        <div style={{visibility:'hidden'}}>end date</div>
                            <Select
                                placeholder={language.Member[currentLanguage]}
                                className='w-ful min-w-40 h-9'
                                options={memberoptions}
                                value={selectedOptionMember}
                                onChange={handlechangeMember} />
                        </div>

                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                        <div>{language.Start_date[currentLanguage]}</div>
                            <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                type='date'
                                    value={startDate}
                                    onChange={(date)=>handleStartDate(date.target.value)}
                                    placeholderText="Start date"
                                    className='rounded w-full h-9 p-2'
                                />
                            </div>
                        </div>

                        <div className='flex flex-col text-gray-600 sm:mt-0 mt-3'>
                        <div>{language.End_date[currentLanguage]}</div>
                        <div className='w-full rounded' style={{ border: '1px solid silver' }}>
                                <input
                                type='date'
                                    value={endDate}
                                    onChange={(date)=>handleEndDate(date.target.value)}
                                    isClearable
                                    placeholderText="End date"
                                    className='rounded w-full h-9'
                                />
                            </div>
                        </div>

                        {(selectedOptionKla || selectedOptionsession || selectedOptionEvent || selectedOptionMember ||startDate || endDate) && (
                            <div className='flex flex-col '>
                            <div style={{visibility:'hidden'}}>end date</div>

                                <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                <span>{language.Clear_Filter[currentLanguage]}</span>
                                <Icon icon="bx:reset" />
                                    </button>

                        </div>)}

                    </div>
                    }

                    {!isGridView ? <TableSearch erm={searchError??null} isFiltered={isFiltered} handleResetFilter={handleResetFilter} isFilterCleared={isFilterCleared} clearedAllFilter={clearedAllFilter} /> : <GridSearch />}

                </div>

            </div>
        </>
    )
}

export default SearchResult